module.exports = __webpack_public_path__ + "img/QUAD.29342a26.svg";